/**
 * A map of lists. Automatically creates and removes lists as needed.
 * TODO: Consider using a Set instead of an Array for the values.
 */
export default class MultiMap<K, V> {
  private map: Map<K, V[]>;

  constructor() {
    this.map = new Map<K, V[]>();
  }

  /** Adds a value to the list associated with the given key */
  add(key: K, value: V): void {
    if (!this.map.has(key)) {
      this.map.set(key, [value]);
    } else {
      this.map.get(key)!.push(value);
    }
  }

  /** Gets the list of values for the given key, returns empty array if key doesn't exist */
  get(key: K): ReadonlyArray<V> {
    return this.map.get(key) ?? [];
  }

  /** Checks if a specific key-value pair exists in the map */
  has(key: K, value: V): boolean {
    return this.map.has(key) && this.map.get(key)!.includes(value);
  }

  /** Removes a specific value from the list associated with the given key */
  remove(key: K, value: V): void {
    if (this.map.has(key)) {
      const array = this.map.get(key)!;
      const index = array.indexOf(value);
      if (index >= 0) {
        array.splice(index, 1);
        if (array.length === 0) {
          this.map.delete(key);
        }
        return;
      }
    }
    throw new Error(`<${key}:${value}> not found`);
  }
}
